import axios from 'axios';
import { API_URL } from '../config/apiConfig';


export const fetchAffiliates = async (query) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/search-affiliates`, {
            params: { q: query },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching affiliates:", error);
        return [];
    }
};

export const fetchAffiliateInfo = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/get-affiliate-by-id`, {
            params: { id: affiliateId },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching affiliate info:", error);
        return null;
    }
};

export const addHomeAffiliate = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/add-home-affiliate`,
            { affiliateId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error adding home affiliate:", error);
        throw error;
    }
};

export const removeHomeAffiliate = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/remove-home-affiliate`,
            { affiliateId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error removing home affiliate:", error);
        throw error;
    }
};

export const fetchPlans = async (ownerId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/affiliate-plans`, {
            params: { ownerId },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching plans:", error);
        throw error;
    }
};

export const checkHomeAffiliate = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-home-affiliate`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return {
            homeAffiliate: response.data.homeAffiliate || null,
            classFilters: response.data.classFilters || []
        };
    } catch (error) {
        console.error("Error checking home affiliate:", error);
        return {
            homeAffiliate: null,
            classFilters: []
        };
    }
};

export const getUserFutureClasses = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-future-classes`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user future classes:", error);
        throw error;
    }
};

// Add these functions to getClassesApi.js

// Get notifications for user's home affiliate
export const getUserNotifications = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-notifications`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user notifications:", error);
        throw error;
    }
};

// Mark notification as seen
export const markNotificationSeen = async (notificationId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/mark-notification-seen`,
            { notificationId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error marking notification as seen:", error);
        throw error;
    }
};

// Get all notifications for affiliate (admin)
export const getAffiliateNotifications = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/affiliate-notifications`, {
            params: { affiliateId },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching affiliate notifications:", error);
        throw error;
    }
};

// Create notification
export const createNotification = async (notificationData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/create-notification`,
            notificationData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating notification:", error);
        throw error;
    }
};

// Update notification
export const updateNotification = async (notificationId, notificationData) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.put(`${API_URL}/update-notification/${notificationId}`,
            notificationData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating notification:", error);
        throw error;
    }
};

// Delete notification
export const deleteNotification = async (notificationId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${API_URL}/delete-notification/${notificationId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting notification:", error);
        throw error;
    }
};

// Toggle notification active status
export const toggleNotificationActive = async (notificationId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.patch(`${API_URL}/toggle-notification-active/${notificationId}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error toggling notification status:", error);
        throw error;
    }
};

// Add these functions to your getClassesApi.js file

// Get user's weekly streak status
export const getUserWeeklyStreak = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-weekly-streak`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user weekly streak:", error);
        throw error;
    }
};

// Mark weekly streak notification as seen
export const markWeeklyStreakSeen = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${API_URL}/mark-weekly-streak-seen`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error marking weekly streak as seen:", error);
        throw error;
    }
};

// Get user's streak history (optional)
export const getUserStreakHistory = async (limit = 12) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/user-streak-history`, {
            params: { limit },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user streak history:", error);
        throw error;
    }
};

// Remove from waitlist (using existing deleteWaitlist from classesApi.js)
export const removeFromWaitlist = async (classId, isFamilyMember, familyMemberId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/classes/waitlist/remove`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            data: {
                classId,
                isFamilyMember,
                familyMemberId
            }
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error removing from waitlist:", error);
        throw error;
    }
};